import { render, staticRenderFns } from "./editInformation.vue?vue&type=template&id=4460bc38&scoped=true&"
import script from "./editInformation.vue?vue&type=script&lang=js&"
export * from "./editInformation.vue?vue&type=script&lang=js&"
import style0 from "./editInformation.vue?vue&type=style&index=0&id=4460bc38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4460bc38",
  null
  
)

export default component.exports